const ButtonType = {
  BUTTON: `button`,
  RESET: `reset`
}
const ButtonAction = {
  SUBMIT: `submit`,
  APICALL: `apicall`,
  GOTO: `goto`,
  FUNCTION: `function`
}
const deviceOrdering = [
  {
    id: 99,
    label: 'Sort By',
    value: ''
  },
  {
    id: 0,
    label: `Name`,
    value: `name`
  },
  {
    id: 1,
    label: `Traffic`,
    value: `traffic`
  },
  {
    id: 2,
    label: `Lowest Price`,
    value: `lowest_price`
  },
  {
    id: 3,
    label: `Highest Price`,
    value: `highest_price`
  }
]
const sortOrdering = [
  {
    id: 0,
    label: `Name`,
    value: `title`
  },
  {
    id: 1,
    label: `Traffic`,
    value: `-traffic`
  },
  {
    id: 2,
    label: `Lowest Price`,
    value: `price`
  },
  {
    id: 3,
    label: `Highest Price`,
    value: `-price`
  }
]

export const savedChannel = {
  lifestyle: `device`,
  malls: `device`,
  spbu: `device`,
  airport: `device`
}

const deviceFilter = {
  sort_by: `selectedSortValue`,
  brand: `selectedBrandValue`,
  social: `selectedSocialValue`,
  profile: `selectedProfileValue`,
  location: `selectedLocationValue`,
  lifestyle_type: `selectedTypeValue`,
  property_type: `selectedTypeValue`,
  city: `selectedCityValue`,
  surrounding: `selectedSurroundingValue`,
  departure_type: `selectedDepartureTypeValue`
}

const searchFilter = {
  property_type: `selectedSubQuickValue`,
  category: `selectedQuickFilterValue`,
  search: `searchValue`,
  sort_by: `selectedSortValue`,
  brand: `selectedBrandValue`,
  social: `selectedSocialValue`,
  profile: `selectedProfileValue`,
  location: `selectedLocationValue`,
  city: `selectedCityValue`,
  surrounding: `selectedSurroundingValue`,
  departure_type: `selectedDepartureTypeValue`
}

const days_of_week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

export default {
  ButtonType,
  ButtonAction,
  deviceOrdering,
  deviceFilter,
  searchFilter,
  savedChannel,
  sortOrdering,
  days_of_week,
}
